<script setup lang="ts">
import { Space, Station } from "@soft-db/monitoring-api-client";
import ConfirmationDialog from "../dialogs/ConfirmationDialog.vue";
import StationSaveDiff from "../stations/StationSaveDiff.vue";
import StationSpaceLinkBadge from "./StationSpaceLinkBadge.vue";

const { t } = useI18n();

const { space } = defineProps<{ space: Space }>();

const saveConfirmationRef = useTemplateRef("$stationConfirmation");

const updatedStations = ref<Station[]>([]);
const shouldDisplayConfirmation = computed(() => updatedStations.value.length > 0);

function reveal(stations: Station[]) {
	updatedStations.value = stations;

	if (saveConfirmationRef.value !== null && shouldDisplayConfirmation.value) {
		return saveConfirmationRef.value.reveal(stations);
	} else {
		return { isCanceled: false };
	}
}

defineExpose({ reveal });
</script>

<template>
	<ConfirmationDialog
		ref="$stationConfirmation"
		:title="t('space.stationLink')"
		:description="t('space.stationLinkDescription')"
	>
		<StationSaveDiff
			:fromLabel="t('space.currentSpace')"
			:fromItems="updatedStations"
			:toLabel="t('space.updatedSpace')"
			:toItems="updatedStations"
		>
			<template #from="{ item }">
				<StationSpaceLinkBadge :stationId="item.id" useStationSpace />
			</template>
			<template #to="{ item }">
				<StationSpaceLinkBadge :stationId="item.id" :spaceId="space.id" />
			</template>
		</StationSaveDiff>
	</ConfirmationDialog>
</template>
